const BulletinIcon = ({ size = 24, className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        opacity="0.55"
        d="M7.91797 3.37358C7.91797 3.01139 8.21159 2.71777 8.57378 2.71777H14.9133C15.2755 2.71777 15.5691 3.01139 15.5691 3.37358V4.248C15.5691 4.61019 15.2755 4.90381 14.9133 4.90381H8.57378C8.21159 4.90381 7.91797 4.61019 7.91797 4.248V3.37358Z"
        fill="currentColor"
      />
      <g opacity="0.3">
        <path
          d="M6.27734 12.0085C6.27734 11.4049 6.7667 10.9155 7.37036 10.9155H15.568C16.1716 10.9155 16.661 11.4049 16.661 12.0085C16.661 12.6122 16.1716 13.1016 15.568 13.1016H7.37036C6.7667 13.1016 6.27734 12.6122 6.27734 12.0085Z"
          fill="currentColor"
        />
        <path
          d="M6.27734 15.8347C6.27734 15.231 6.7667 14.7416 7.37036 14.7416H11.7424C12.3461 14.7416 12.8354 15.231 12.8354 15.8347C12.8354 16.4383 12.3461 16.9277 11.7424 16.9277H7.37036C6.7667 16.9277 6.27734 16.4383 6.27734 15.8347Z"
          fill="currentColor"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.8252 4.35742C6.8252 5.26283 7.55947 5.99694 8.46484 5.99707H15.0234C15.9288 5.99694 16.6631 5.26283 16.6631 4.35742V3.81055H18.3027C19.5098 3.81081 20.4883 4.78992 20.4883 5.99707V19.6602C20.4881 20.8671 19.5097 21.8454 18.3027 21.8457H5.18652C3.97933 21.8457 3.0002 20.8673 3 19.6602V5.99707C3 4.78976 3.97921 3.81055 5.18652 3.81055H6.8252V4.35742ZM7.37109 14.7412C6.76771 14.7413 6.27858 15.2306 6.27832 15.834C6.27832 16.4376 6.76755 16.9276 7.37109 16.9277H11.7432C12.3468 16.9277 12.8369 16.4376 12.8369 15.834C12.8367 15.2306 12.3467 14.7412 11.7432 14.7412H7.37109ZM7.37109 10.915C6.76755 10.9152 6.27832 11.4052 6.27832 12.0088C6.27855 12.6122 6.76769 13.1014 7.37109 13.1016H15.5693C16.1727 13.1014 16.6619 12.6121 16.6621 12.0088C16.6621 11.4053 16.1728 10.9152 15.5693 10.915H7.37109Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default BulletinIcon;
